function setCurrentTimezone() {
    let timezone;

    try {
        timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (e) {
        console.log(e);
    }

    if (typeof timezone === "undefined") {
        timezone = 'Europe/Lisbon';
    }

    $('#timezones').val(timezone).trigger('change');

    return timezone;
}

function setTimezoneInfo(currentTimezone = null) {
    let timezoneNameContainer = $('#timezone_name');
    let webinarTimezone = timezoneNameContainer.attr('data-timezone');
    let webinarDate = timezoneNameContainer.attr('data-date');
    let url = timezoneNameContainer.attr('data-url');
    let method = timezoneNameContainer.attr('data-method');
    let timezone = currentTimezone;
    if (timezone === null) {
        timezone = setCurrentTimezone();
    }
    let timezoneInfo = window.timezones[timezone];
    let timezoneLabel = '(GMT ' + timezoneInfo['offset'] + ') ' + timezoneInfo['label'].replace('(GMT)', '');

    $('#modal_timezone').val(timezone).trigger('change');

    $('#timezone_name').html(timezoneLabel);

    $.ajax({
        url: url,
        type: method,
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        dataType: 'json',
        data: {
            date: webinarDate,
            timezone: webinarTimezone,
            toTimezone: timezone,
        },
        success: function (data) {
            $('#timezone_date').html(data.data);
            $('#timezone_modal_date').html(data.data);
        }
    });
}


setTimezoneInfo();

$('body #timezones').on('change', function () {
    setTimezoneInfo($(this).val());
})


$('body .exampleModalDropdown').select2({
    dropdownParent: $('#exampleModal'),
    templateResult: function (item) {
        return formatPhone(item, false);
    }
});


$('#restore_bar').on('click', function (e) {
    setTimeout(function () {
        $('#sec-5d8b').addClass('u-dialog-open')
    }, 1000);
})

function formatPhone(item, state) {
    if (!item.id) {
        return item.text;
    }
    var countryUrl = "https://www.mundohbl.com/images/flags/";
    var stateUrl = "https://oxguy3.github.io/flags/svg/us/";
    var url = state ? stateUrl : countryUrl;
    var img = $("<img>", {
        class: "img-flag",
        width: 26,
        src: url + item.element.getAttribute('data-country').toLowerCase() + ".svg"
    });
    var span = $("<span>", {
        text: " " + item.text
    });
    span.prepend(img);
    return span;
}
